var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-anam-test.7602ff86.png","uri@2x": __webpack_public_path__ + "icon-anam-test.82a860d6.png","uri@3x": __webpack_public_path__ + "icon-anam-test.ac87eda6.png",
    width: 20,
    height: 20
});